// extracted by mini-css-extract-plugin
module.exports = {"CartIcon":"EmptyCart_CartIcon__1wSoO","CartEmptyContainer":"EmptyCart_CartEmptyContainer__YHElc"};